import React from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "../../contexts/AdminAuthContext";

const LogoutButton: React.FC = () => {
  const { logout } = useAdminAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <button
      onClick={handleLogout}
      style={{
        padding: "8px 12px",
        borderRadius: 6,
        border: "1px solid #d9e1ff",
        background: "#f7f9ff",
        color: "#1b3bcc",
        cursor: "pointer",
        fontWeight: 600,
      }}
    >
      Logout
    </button>
  );
};

export default LogoutButton;

